import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../MissionAndVission/MissioonSideCards/MissioonSideCards.css";
import "../../TravelArrangements/TravelArrangementsSideCards/TravelArrangementsSideCards.css";

const GovSideCards = () => {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="safetyCardBox mt-0 mb-lg-5 pb-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <h1 className="headings mt-3 gov-headings  ps-2 ps-md-0">
                <span>Travel Policies</span> and Compliances:
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Navigating the complex world of government travel regulations
                can be daunting. Our expertise lies in devising and implementing
                travel policies that adhere to government guidelines and
                specific agency requirements. We ensure your travel programs
                conform to relevant laws, regulations, and ethical standards
                while minimizing risks and complying with government mandates.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Our team stays abreast of policy updates, providing proactive
                guidance and support so your organization always remains
                compliant. From developing clear travel policies and training
                sessions to audits and regular auditing procedures, our
                comprehensive suite of services ensures your travel program
                operates within government regulations.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/gov1.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBoxReverse mb-lg-5 pb-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <h1 className="headings mt-3 gov-headings ps-2 ps-md-0">
                <span>Procurement </span> and Contracts Management{" "}
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Optimization and value maximization in organizations' travel
                spending are paramount. Our procurement and contracting
                expertise allows us to leverage market knowledge in negotiating
                competitive rates from airlines, hotels, and other travel
                suppliers—thus saving your organization significant costs!
              </p>
              <p className="missionP-two px-2 px-md-0">
                At Blueberry Travel, we recognize the significance of
                transparency and accountability in government procurement. Our
                team adheres to all applicable procurement regulations, creating
                an equitable vendor experience. In addition, we provide detailed
                documentation and reporting so you have complete visibility over
                travel-related expenditures while adhering to all necessary
                government regulations.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/gov2.png"
                alt=""
                className="safetyTravelimg safetyTravelimg2 mission-images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="safetyCardBox mb-lg-5 pb-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <h1 className="headings mt-3 gov-headings ps-2 ps-md-0">
                <span>Booking </span>and Reservation
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Our state-of-the-art booking and reservation platform simplifies
                travel booking for government employees, offering easy access to
                flights, hotels, rental cars, and ground transportation options.
                Our experienced travel consultants are on call 24-7 to assist
                with complex itineraries while offering personalized advice,
                ensuring a hassle-free booking experience!
              </p>
              <p className="missionP-two px-2 px-md-0">
                We utilize cutting-edge technology to streamline the booking
                process and maximize efficiency. Our online booking tool
                features real-time availability and competitive pricing to allow
                travelers to book travel itineraries effortlessly.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-4">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/gov3.png"
                alt=""
                className="safetyTravelimg mission-images"
                loading="lazy"
              />
            </div>
          </div>
          <div className="safetyCardBoxReverse ct-lastcard-mb mb-lg-5 pb-5">
            <div className="col-lg-6 col-md-6 col-sm-12 mt-xxl-4">
              <h1 className="headings mt-3 gov-headings ps-2 ps-md-0">
                <span>Security </span>and Risk Administration
              </h1>
              <p className="missionP-one px-2 px-md-0">
                Protecting government travelers is our highest priority, so we
                offer comprehensive security and risk management solutions
                designed to mitigate threats while assuring employee well-being
                while traveling. These include travel risk evaluation, emergency
                response planning services, and 24/7 global monitoring
                capabilities.
              </p>
              <p className="missionP-two px-2 px-md-0">
                Utilizing real-time data and intelligence, our team utilizes
                comprehensive travel security briefings and alerts to
                proactively identify and mitigate travel risk. When an emergency
                strikes, our immediate assistance ensures employee well-being is
                preserved, ensuring safe travel environments for government
                employees.
              </p>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-xxl-5 mb-5 mb-md-0">
              <LazyLoadImage
                src="https://blueberrywebsites.azureedge.net/bbt/images/gov4.png"
                alt=""
                className="safetyTravelimg safetyTravelimg2 mission-images"
                loading="lazy"
              />
            </div>
          </div>

          {/* <div className='safetyCardBox'>
                        <div className='col-lg-6 col-md-6 col-sm-12 mt-xxl-5'>
                            <h1 className='headings mt-3 missionHeading ps-2 ps-md-0'><span>Our</span> Core Values
                            </h1>
                            <p className='missionP-one'>
                                We prioritize the needs and satisfaction of our clients above all.
                            </p>
                            <p className='missionP-two'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        </div>

                        <div className='col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-5'>
                            <LazyLoadImage
            effect="blur"
 src={tracking} alt="" className='safetyTravelimg mission-images' />
                        </div>
                    </div> */}
        </div>
      </div>
    </>
  );
};

export default GovSideCards;
